import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import { Suspense } from 'react';

import { Provider } from 'react-redux';

import store from './store';

import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css'

import './assets/css/theme.css';
import './assets/css/index.css';
import './assets/css/loading.css';
import './assets/css/perfect-scrollbar.css'

import { BrowserRouter } from 'react-router-dom';

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));

document.title = 'TrackTr - A Fleet Tracking Solution';

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<div className='loading' />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
